import React from 'react'
import {
    HeroBlockSection,
    HeroContentSection,
    StyledHeroSubText,
    StyledHeroTitle,
    StyledPageTitle,
    StyledTitleContainer,
    StyledRightContainer,
    StyledLeftContainer,
} from './TWHeroBlock.styled'

type TWHeroBlockProps = {
    title: string
    description: string
    pageTitle: string
    rightContent: React.ReactNode
    leftExtraContent?: React.ReactNode
}

export function TWHeroBlock({
    title,
    description,
    pageTitle,
    rightContent,
    leftExtraContent,
}: TWHeroBlockProps) {
    return (
        <HeroBlockSection>
            <HeroContentSection>
                <StyledLeftContainer>
                    <StyledTitleContainer>
                        <StyledPageTitle>{pageTitle}</StyledPageTitle>
                        <StyledHeroTitle>{title}</StyledHeroTitle>
                    </StyledTitleContainer>
                    <StyledHeroSubText>{description}</StyledHeroSubText>
                    {leftExtraContent}
                </StyledLeftContainer>
                <StyledRightContainer>{rightContent}</StyledRightContainer>
            </HeroContentSection>
        </HeroBlockSection>
    )
}
